<template>
  <v-card elevation="0">
    <v-card-title>TO DO</v-card-title>
    <v-progress-linear
      v-model="progressVal"
      color="indigo"
      background-color="grey lighten-2"
      height="1"
    ></v-progress-linear>
    <v-card-text>
      <v-row
        v-for="(item, i) in items"
        :key="i"
        dense
        align="center"
        justify="space-between"
        class="mb-4"
      >
        <template v-if="item.modi">
          <!-- <v-form v-model="validModi" ref="form" @submit.prevent="onModiTodo"> -->
          <v-col cols="4">
            <v-select
              v-model="item.prjNo"
              :items="projectName"
              item-text="prjNm"
              item-value="prjNo"
              label="관련 프로젝트"
              :rules="[rules.required]"
              required
            ></v-select>
          </v-col>
          <v-col cols="7">
            <v-text-field
              v-model="item.planText"
              :label="item.planText"
              :rules="[rules.required]"
              single-line
              ref="inpModi"
            >
              <!-- @keydown.native="hideModi"
                @focusout.native="hideModi" -->
            </v-text-field>
          </v-col>
          <!-- <v-col cols="1" align-self="center">
            <v-btn type="submit" fab small elevation="0" color="transparent">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col> -->
          <!-- </v-form> -->
        </template>
        <template v-else>
          <v-col cols="11">
            <v-checkbox
              v-model="checkbox"
              :label="item.planText"
              :value="item.planNo"
              color="orange"
              hide-details
              class="mt-0 pt-0"
              @change="onCheck(item)"
            >
              <template v-slot:label>
                <div :class="item.cmplYn === 'Y' ? 'checked' : ''">
                  {{ item.planText }}
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </template>
        <v-col cols="1">
          <v-menu bottom right rounded>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <template v-if="!item.modi">
                <v-list-item link @click="showModi(item)">
                  <v-list-item-title>수정</v-list-item-title>
                </v-list-item>
              </template>
              <template v-else>
                <v-list-item link @click="onModiTodo(item)">
                  <v-list-item-title>저장</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="hideModi">
                  <v-list-item-title>수정취소</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item link @click="removeTodo(item)">
                <v-list-item-title>삭제</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-form v-model="valid" ref="form" @submit.prevent="onCreateTodo">
        <v-row dense>
          <v-col cols="4" align-self="center">
            <v-select
              v-model="form.prjNo"
              :items="projectName"
              item-text="prjNm"
              item-value="prjNo"
              label="관련 프로젝트"
              :rules="[rules.required]"
              required
            ></v-select>
          </v-col>
          <v-col cols="7" align-self="center">
            <v-text-field
              v-model="form.planText"
              label="새로운 할일"
              :rules="[rules.required]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="1" align-self="center">
            <v-btn type="submit" fab small elevation="0" color="transparent">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { loadTodo, createTodo, modiTodo, delTodo } from "@/api/todo";
import { planSelect } from "@/api/plan";

export default {
  data() {
    return {
      valid: true,
      validModi: true,
      items: [],
      checkbox: [],
      projectName: [],
      form: { planText: "", prjNo: "" },
      modiItem: null,
      rules: {
        required: value => !!value || "필수 항목입니다.",
      },
    };
  },
  computed: {
    progressVal() {
      return (this.checkbox.length / this.items.length) * 100;
    },
  },
  created() {
    this.todoList();
    this.loadSelect();
  },
  methods: {
    async loadSelect() {
      try {
        const { data } = await planSelect("prj");
        this.projectName = data.prjList;
      } catch (error) {
        console.error(error.response);
      }
    },
    async todoList() {
      try {
        const { data } = await loadTodo();
        const checked = data.list
          .filter(v => v.cmplYn === "Y")
          .map(v => v.planNo);

        const list = data.list.map(v => ({ ...v, modi: false }));

        this.items = list;
        this.checkbox = checked;
      } catch (error) {
        console.error(error);
      }
    },
    async onCreateTodo() {
      this.$refs.form.validate();

      if (!this.valid) return false;

      try {
        await createTodo(this.form);
        this.form = {};
        this.todoList();
        this.$refs.form.resetValidation();
      } catch (error) {
        console.error(error);
      }
    },
    async removeTodo(item) {
      try {
        await delTodo(item.planNo);
        this.todoList();
      } catch (error) {
        console.error(error);
      }
    },
    async modifyTodo(id, formData) {
      try {
        await modiTodo(id, formData);
        this.modiItem = null;
        this.todoList();
      } catch (error) {
        console.error(error);
      }
    },
    onModiTodo(item) {
      // 수정
      this.modifyTodo(item.planNo, item);
    },
    onCheck(item) {
      // 할일 완료시
      this.items.map(v => {
        if (v.planNo === item.planNo) {
          if (item.cmplYn === "Y") {
            v.cmplYn = "N";
          } else {
            v.cmplYn = "Y";
          }
        }
      });

      this.modifyTodo(item.planNo, { cmplYn: item.cmplYn });
    },
    showModi(item) {
      // 수정 모드
      this.items.map(v => {
        v.modi = false;
        if (v.planNo === item.planNo) {
          v.modi = true;
          this.$nextTick(() => this.$refs.inpModi[0].focus());
        }
      });
      this.modiItem = item;
    },
    hideModi() {
      // 수정 취소
      this.items.map(v => {
        v.modi = false;
      });
    },
  },
};
</script>

<style scoped>
.checked {
  text-decoration: line-through;
}
</style>
